function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm0 19a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 19zm1.6-6.08a1 1 0 0 0-.6.917 1 1 0 1 1-2 0 3 3 0 0 1 1.8-2.75A2 2 0 1 0 10 9.255a1 1 0 1 1-2 0 4 4 0 1 1 5.6 3.666z"
});

var SvgQuestionCircleBold = function SvgQuestionCircleBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgQuestionCircleBold;